// Version 4 (30.10.2026): unter /en englische Adressen (src/v4/i18n/slugs.js). Version 1 bis 3 unverändert.
import { toEnPath, toDePath } from "../v4/i18n/slugs";
import { getVersion } from "../version/VersionContext";

const v4 = () => getVersion() === "4";

export const isEnglishPath = (pathname = "") => pathname === "/en" || pathname.startsWith("/en/");

export const stripLocalePrefix = (pathname = "/") => {
    if (!isEnglishPath(pathname)) return pathname || "/";
    const path = pathname.slice(3) || "/";
    return v4() ? toDePath(path) : path;
};

export const localizePath = (to, lang = "de") => {
    if (typeof to !== "string" || !to.startsWith("/") || to.startsWith("//")) return to;

    const suffixIndex = to.search(/[?#]/);
    const pathname = suffixIndex === -1 ? to : to.slice(0, suffixIndex);
    const suffix = suffixIndex === -1 ? "" : to.slice(suffixIndex);
    const localPath = stripLocalePrefix(pathname);
    const enPath = v4() ? toEnPath(localPath) : localPath;
    const localized = lang === "en" ? `/en${enPath === "/" ? "/" : enPath}` : localPath;
    return `${localized}${suffix}`;
};

export const localeFromPath = (pathname = "") => (isEnglishPath(pathname) ? "en" : "de");
